import { useBoardStatuses } from '@/features/boards/public';
import type { ProjectStatus } from '../types';
import type { BoardStatus } from '@/features/boards/public';
import { statusTypeFromApi } from '../adapters/status-type.mapper';

function toProjectStatus(s: BoardStatus): ProjectStatus {
  return {
    id: s.id ?? '',
    name: s.name ?? '',
    type: statusTypeFromApi(s.type),
    color: s.color ?? '',
    order: s.order,
    boardId: s.boardId ?? '',
    wipLimit: s.wipLimit,
  };
}

export function useProjectStatuses(boardId: string) {
  const result = useBoardStatuses(boardId);
  return {
    statuses: result.statuses.map(toProjectStatus),
    isLoading: result.isLoading,
  };
}
